// Assumes all parts of version strings contain positive integers
const compareVersions = (
  version1: string,
  version2: string,
): number => {
  const v1 = version1.split('.').map((part) => parseInt(part, 10));
  const v2 = version2.split('.').map((part) => parseInt(part, 10));

  // Compare parts of equal length;
  const length = Math.min(v1.length, v2.length);
  for (let i = 0; i < length; i += 1) {
    const diff = v2[i] - v1[i];
    if (diff !== 0) {
      return diff;
    }
  }

  // Compare remaining parts. If they contain all zeroes, consider versions equal
  if (v1.length > length) {
    return v1.slice(length).some((item) => !!item) ? -1 : 0;
  }
  if (v2.length > length) {
    return v2.slice(length).some((item) => !!item) ? 1 : 0;
  }
  return 0;
};

export default compareVersions;
